"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  DocumentPODDisposition
} from "../accounts_payable/data/types/Pb";
import { documentLoadRelationshipServiceGetRelationshipsForDocumentsAndLoads } from "../accounts_payable/data/types/Api";
class LoadDocumentRelationshipService {
  constructor() {
    __publicField(this, "cachedRelationships", []);
    __publicField(this, "cachedDocumentIds", /* @__PURE__ */ new Set());
    __publicField(this, "cachedLoadStateIds", /* @__PURE__ */ new Set());
  }
  getRelationshipData(documentIds, loadStateIds) {
    return __async(this, null, function* () {
      const newDocumentIds = documentIds.filter(
        (id) => !this.cachedDocumentIds.has(id)
      );
      const newLoadStateIds = loadStateIds.filter(
        (id) => !this.cachedLoadStateIds.has(id)
      );
      if (newDocumentIds.length > 0 || newLoadStateIds.length > 0) {
        const documentIdsToFetch = newLoadStateIds.length > 0 ? documentIds : newDocumentIds;
        const loadStateIdsToFetch = newDocumentIds.length > 0 ? loadStateIds : newLoadStateIds;
        const request = {
          document_ids: documentIdsToFetch,
          load_state_ids: loadStateIdsToFetch
        };
        const response = yield documentLoadRelationshipServiceGetRelationshipsForDocumentsAndLoads(
          request
        );
        for (const newRelationship of response.relationships) {
          const existingIndex = this.cachedRelationships.findIndex(
            (r) => r.document_id === newRelationship.document_id && r.load_state_id === newRelationship.load_state_id
          );
          if (existingIndex >= 0) {
            this.cachedRelationships[existingIndex] = newRelationship;
          } else {
            this.cachedRelationships.push(newRelationship);
          }
        }
        newDocumentIds.forEach((id) => this.cachedDocumentIds.add(id));
        newLoadStateIds.forEach((id) => this.cachedLoadStateIds.add(id));
      }
      return this.cachedRelationships;
    });
  }
  /**
   * Force the pod_disposition for all cached relationships for a given document.
   * Used when the user manually toggles the POD checkbox to immediately reflect
   * the change in the UI without waiting for a page reload.
   */
  forcePodDispositionForDocument(documentId, isPod) {
    const disposition = isPod ? DocumentPODDisposition.DocumentPODDispositionKnownPOD : DocumentPODDisposition.DocumentPODDispositionKnownNotPOD;
    for (const relationship of this.cachedRelationships) {
      if (relationship.document_id === documentId) {
        relationship.pod_disposition = disposition;
      }
    }
  }
}
const loadDocumentRelationshipService = new LoadDocumentRelationshipService();
export default loadDocumentRelationshipService;
